"use client"

import { Globe } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useCurrencyStore, type Currency } from "@/store/use-currency-store"

const CURRENCY_OPTIONS: { code: Currency; symbol: string; label: string }[] = [
  { code: 'RUB', symbol: '₽', label: 'RUB' },
  { code: 'USD', symbol: '$', label: 'USD' },
  { code: 'EUR', symbol: '€', label: 'EUR' },
]

export function CurrencySelector() {
  const currency = useCurrencyStore((s) => s.currency)
  const setCurrency = useCurrencyStore((s) => s.setCurrency)

  const current = CURRENCY_OPTIONS.find((o) => o.code === currency) ?? CURRENCY_OPTIONS[0]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 gap-1.5 px-2 text-xs text-muted-foreground hover:text-foreground"
        >
          <Globe className="size-3.5" />
          <span className="hidden sm:inline">
            {current.symbol} {current.label}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36">
        {CURRENCY_OPTIONS.map((opt) => (
          <DropdownMenuItem
            key={opt.code}
            onClick={() => setCurrency(opt.code)}
            className={currency === opt.code ? 'bg-accent' : ''}
          >
            <span className="mr-2 font-medium">{opt.symbol}</span>
            {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
